
















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { historyStage } from '@/api/project';
import { roundList } from '@/api/common';
interface Node {
  name: String;
  person: String;
  createDate: String;
}

interface Form {
  round: Number | null;
}

@Component({
  components: {}
})
class RoundSelect extends Vue {
  @Prop()
  allowClear;

  @Prop()
  companyId;

  @Prop()
  type;
  // 0:可选所有轮次
  // 1:仅可选新轮次 2:仅可选最近融资期轮或新轮次
  // 3:仅可选非当前项目轮次(不可选置灰) 4:仅可选当前项目轮 次(不可选置灰)

  @Prop()
  value; // round

  @Prop()
  disabled;

  @Prop()
  disableIds;

  totalSelectionList: any[] = [];
  selectionList: any[] = [];
  filterSelectionList: any[] = [];
  selected = null;
  created() {
    this.initSelection();
  }

  @Watch('type')
  typeChange(value) {
    this.handleChange('');
    this.initSelection();
  }

  @Watch('value')
  valueChange(value) {
    let tmp = this.totalSelectionList.find(_ => _.id === value && _.status === -1);
    // 如果是禁用轮次就显示名字,如果是空(id为-1)就置空
    this.selected = tmp ? tmp.name : value === -1 ? '' : value;
  }
  async initSelection() {
    let res = await roundList();
    let listTotal = res.data || [];
    let list = listTotal.filter(_ => _.status === 0);
    let { type } = this;
    if (type === 1 || type === 2) {
      let res1 = await historyStage({
        type: 0,
        id: this.companyId
      });
      let stageList = res1.data || [];
      let hisRoundMap = stageList.reduce((map, cur) => {
        map[cur.round] = true;
        return map;
      }, {});
      let latestRound;
      if (stageList.length) {
        latestRound = stageList[stageList.length - 1].round;
      }
      list.forEach(_ => {
        if (type === 1) {
          _.disabled = hisRoundMap[_.id];
        } else {
          _.disabled = hisRoundMap[_.id] && _.id !== latestRound;
        }
      });
      if (!this.value && this.type !== 1) {
        this.handleChange(latestRound);
      }
    } else if (type === 3 || type === 4) {
      let res1 = await historyStage({
        type: 1,
        id: this.companyId
      });
      let stageList = res1.data || [];
      let hisRoundMap = stageList.reduce((map, cur) => {
        map[cur.round] = true;
        return map;
      }, {});
      if (type === 3) {
        list.forEach(_ => {
          _.disabled = hisRoundMap[_.id];
        });
      } else {
        list = list.filter(_ => hisRoundMap[_.id]);
      }
    }
    this.totalSelectionList = listTotal;
    this.selectionList = list;
    this.filterSelectionList = list;
    if (this.value) {
      let tmp = this.totalSelectionList.find(_ => _.id === this.value && _.status === -1);
      this.selected = tmp ? tmp.name : this.value === -1 ? '' : this.value;
    }
  }

  handleChange(key) {
    this.selected = key;
    let tmp = this.totalSelectionList.find(_ => _.id === key);
    this.$emit('input', key); // 绑定v-model,需要在change时间之前
    this.$emit('change', { round: key, roundName: tmp ? tmp.name : '' });
  }

  handleSearch(key) {
    if (key) {
      this.$nextTick(() => {
        // 匹配大小写搜索
        this.filterSelectionList = this.selectionList.filter(_ => new RegExp(key, 'i').test(_.name));
      });
    } else {
      this.filterSelectionList = this.selectionList;
    }
  }
}

export default RoundSelect;
